import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { TripDetail } from 'src/app/api/commonInterfaces';
import { LinkableTripsService } from 'src/app/api/linkable-trips.service';
import { LinkModes, OnTripLinkValues } from '../../link-trip/link-trip.component';

@Component({
    selector: 'app-link-trip-modal',
    templateUrl: './link-trip-modal.component.html',
    styleUrls: ['./link-trip-modal.component.scss'],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LinkTripModalComponent implements OnInit {


  trips: TripDetail[] = [];
  incidentId: number = -1;
  linkMode: LinkModes = LinkModes.Link;

  constructor(
    private linkableTripService: LinkableTripsService,
    public modalRef: DynamicDialogRef,
    public config: DynamicDialogConfig
  ) {


    if (!config.data.incidentId) throw new Error("incidentId must be provided for Trip Link Modal")
    if (!config.data.linkMode) throw new Error("linkMode must be provided for Trip Link Modal")

    this.incidentId = config.data.incidentId
    this.linkMode = config.data.linkMode
    this.trips = config.data.trips

  }

  ngOnInit(): void {

    if (!this.trips || this.trips.length === 0) {
      this.linkableTripService.getLinkableTrips().subscribe({
        next: (trips) => {
          this.trips = trips;

          if (this.linkMode === LinkModes.Unlink) {
            this.trips = this.trips.filter(trip => trip.id !== this.incidentId);
          }

        }
      })
    }
  }


  onLink(result: OnTripLinkValues) {
        this.modalRef.close(result);
  }

}
